/* eslint-disable import/prefer-default-export */

export const SET_TITLE = 'DEFAULT_LAYOUT/SET_TITLE';
export const SET_BACK = 'DEFAULT_LAYOUT/SET_BACK';
